export default __webpack_public_path__ + "static/media/affiche2015.60a038a1.png";